import { cn } from '@/platform/lib/utils';
import SegmentContent from './SegmentContent';
import SegmentFooter from './SegmentFooter';
import SegmentHeader from './SegmentHeader';

const Segment = ({ floating = false, className, children, ...props }) => (
    <div
        className={cn(
            'rounded-xl border border-gray-200 bg-white shadow-sm not-last:mb-4',
            floating && 'sticky bottom-0 z-41 mt-4',
            className
        )}
        {...props}
    >
        {children}
    </div>
);

Segment.Header = SegmentHeader;
Segment.Content = SegmentContent;
Segment.Footer = SegmentFooter;

export default Segment;
